import { render, staticRenderFns } from "./PasswordCriteria.vue?vue&type=template&id=22bf6ead&scoped=true&"
import script from "./PasswordCriteria.vue?vue&type=script&lang=ts&"
export * from "./PasswordCriteria.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordCriteria.vue?vue&type=style&index=0&id=22bf6ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf6ead",
  null
  
)

export default component.exports